

export const ListingColumns = [
  { label: 'Property Name', fieldName: 'propertyName', type: 'text' },
  { label: 'City', fieldName: 'city', type: 'text' },
  { label: 'State', fieldName: 'state', type: 'text' },
  { label: 'Year Built', fieldName: 'yearBuilt', type: 'text' },
  { label: 'Year Renovated', fieldName: 'yearRenovated', type: 'text' },
  { label: 'Units', fieldName: 'propertyTotalUnits', type: 'number' },
  { label: 'Property Type', fieldName: 'omniViewPropertyType', type: 'text' },
  { label: 'Property SubType', fieldName: 'subType', type: 'text' },
  { label: 'List Price', fieldName: 'suggestedPurchasePrice', type: 'currency', decimalFormat: '0' },
  { label: 'Price Per Unit', fieldName: 'propertyPricePerUnit', type: 'currency', decimalFormat: '0' },
  { label: 'List Date', fieldName: 'datePutOnMarket', type: 'date' },
  { label: 'Listed By', fieldName: 'listingGroup', type: 'text' },
  { label: 'Comments (which is the Broker name & contact info)', fieldName: 'comments', type: 'text' },
  { label: 'Owner Account Name', fieldName: 'salesforceAccountName', type: 'text' },
  { label: 'Owner Contact Name', fieldName: 'salesforceContactName', type: 'text' },
  { label: 'Owner Contact Phone', fieldName: 'currentOwnerPhone', type: 'text' },
  { label: 'Owner Contact Email', fieldName: 'currentOwnerEmail', type: 'text' },
  { label: 'Account Relationship Manager', fieldName: 'accountRelationshipManager', type: 'text' },
  { label: 'MB Account Status', fieldName: 'mbAccountStatus', type: 'text' },
  { label: 'Ownership Status', fieldName: 'ownershipStatus', type: 'text' },
  // { label: 'Account Ownership Status (the new Solicitable/Non-Solicitable', fieldName: '', type: 'text' },
]

export const SalesColumns = [
  { label: 'Property Name', fieldName: 'propertyName', type: 'text' },
  { label: 'Property Address', fieldName: 'addressLine1', type: 'text' },
  { label: 'City', fieldName: 'city', type: 'text' },
  { label: 'State', fieldName: 'state', type: 'text' },
  { label: 'Year Built', fieldName: 'yearBuilt', type: 'text' },
  { label: 'Year Renovated', fieldName: 'yearRenovated', type: 'text' },
  { label: 'Units', fieldName: 'propertyTotalUnits', type: 'number' },
  { label: 'Property Type', fieldName: 'omniViewPropertyType', type: 'text' },
  { label: 'Property SubType', fieldName: 'subType', type: 'text' },
  { label: 'RSF', fieldName: 'squareFeet', type: 'number' },
  { label: 'Metering', fieldName: 'metering', type: 'text' },
  { label: 'Sale Date', fieldName: 'saleDate', type: 'date' },
  { label: 'Sale Price', fieldName: 'salePrice', type: 'currency', decimalFormat: '0' },
  { label: 'Price per Unit', fieldName: 'transactionHistoryPricePerUnit', type: 'currency', decimalFormat: '0' },
  { label: 'Price per SF', fieldName: 'pricePerSf', type: 'currency', decimalFormat: '2' },
  { label: 'Cap Rate', fieldName: 'transactionHistoryCapRate', type: 'percent' },
  { label: 'GRM', fieldName: 'grossRentMultiplier', type: 'number', decimalFormat: '2' },
  { label: 'Terms', fieldName: 'termsOfSale', type: 'text' },
  // { label: 'Seller Account Name', fieldName: '', type: 'text' },
  // { label: 'Seller Contact Name', fieldName: '', type: 'text' },
  // { label: 'Seller Contact Phone', fieldName: '', type: 'text' },
  // { label: 'Seller Contact Email', fieldName: '', type: 'text' },
  // { label: 'Seller Relationship Manager', fieldName: '', type: 'text' },
  // { label: 'Seller MB Account Status', fieldName: '', type: 'text' },
  // { label: 'Seller Account Ownership Status (the new Solicitable/Non-Solicitable', fieldName: '', type: 'text' },
  { label: 'Owner Account Name', fieldName: 'salesforceAccountName', type: 'text' },
  { label: 'Owner Contact Name', fieldName: 'salesforceContactName', type: 'text' },
  { label: 'Owner Contact Phone', fieldName: 'currentOwnerPhone', type: 'text' },
  { label: 'Owner Contact Email', fieldName: 'currentOwnerEmail', type: 'text' },
  { label: 'Account Relationship Manager', fieldName: 'accountRelationshipManager', type: 'text' },
  { label: 'MB Account Status', fieldName: 'mbAccountStatus', type: 'text' },
  { label: 'Ownership Status', fieldName: 'ownershipStatus', type: 'text' },
]

export const LoanMaturitiesColumns = [
  { label: 'Property Name', fieldName: 'propertyName', type: 'text' },
  { label: 'Property Address', fieldName: 'addressLine1', type: 'text' },
  { label: 'City', fieldName: 'city', type: 'text' },
  { label: 'State', fieldName: 'state', type: 'text' },
  { label: 'Year Built', fieldName: 'yearBuilt', type: 'text' },
  { label: 'Year Renovated', fieldName: 'yearRenovated', type: 'text' },
  { label: 'Units', fieldName: 'propertyTotalUnits', type: 'number' },
  { label: 'Property Type', fieldName: 'omniViewPropertyType', type: 'text' },
  { label: 'Property SubType', fieldName: 'subType', type: 'text' },
  { label: 'Most Recent Sale Date', fieldName: 'mostRecentSaleDate', type: 'date' },
  { label: 'Most Recent Sale Price', fieldName: 'mostRecentSalePrice', type: 'currency', decimalFormat: '0' },
  // { label: 'Most Recent Price per Unit', fieldName: '', type: 'text' },
  // { label: 'Most Recent Price per SF', fieldName: '', type: 'text' },
  // { label: 'Most Recent Cap Rate', fieldName: '', type: 'text' },
  { label: 'Origination Date', fieldName: 'originationDate', type: 'date' },
  { label: 'Original Loan Amount', fieldName: 'loanHistoryOriginalLoanAmount', type: 'number' },
  { label: 'Interest Rate', fieldName: 'interestRate', type: 'number' },
  { label: 'Rate Type', fieldName: 'rateType', type: 'text' },
  { label: 'Maturity Date', fieldName: 'loanHistoryMaturityDate', type: 'date' },
  { label: 'Interest Only Term', fieldName: 'ioTerm', type: 'text' },
  { label: 'Originator', fieldName: 'originator', type: 'text' },
  { label: 'Lender', fieldName: 'loanHistoryLender', type: 'text' },
  { label: 'Current UPB', fieldName: 'unpaidPrincipalBalance', type: 'number' },
  // { label: 'Berkadia Serviced', fieldName: '', type: 'number' },
  // { label: 'Prepayment Notes', fieldName: '', type: 'number' },
  { label: 'Owner Account Name', fieldName: 'salesforceAccountName', type: 'text' },
  { label: 'Owner Contact Name', fieldName: 'salesforceContactName', type: 'text' },
  { label: 'Owner Contact Phone', fieldName: 'currentOwnerPhone', type: 'text' },
  { label: 'Owner Contact Email', fieldName: 'currentOwnerEmail', type: 'text' },
  { label: 'Account Relationship Manager', fieldName: 'accountRelationshipManager', type: 'text' },
  { label: 'MB Account Status', fieldName: 'mbAccountStatus', type: 'text' },
  { label: 'Ownership Status', fieldName: 'ownershipStatus', type: 'text' },
  // { label: 'Account Ownership Status (the new Solicitable/Non-Solicitable', fieldName: '', type: 'text' },

]

// Occupancy	RSF	Avg SF	Avg Market  Rent	Avg Rent/SF	MR/Bed	ER/Bed	Updated	Notes

export const RentColumns = [
  { label: 'Property Name', fieldName: 'propertyName', type: 'text' },
  { label: 'Property Address', fieldName: 'addressLine1', type: 'text' },
  { label: 'City', fieldName: 'city', type: 'text' },
  { label: 'State', fieldName: 'state', type: 'text' },
  { label: 'Year Built', fieldName: 'yearBuilt', type: 'text' },
  { label: 'Year Renovated', fieldName: 'yearRenovated', type: 'text' },
  { label: 'Occupancy', fieldName: 'occupancy', type: 'percent' },
  { label: 'Units', fieldName: 'propertyTotalUnits', type: 'number' },
  { label: '# Beds', fieldName: 'totalBeds', type: 'number' },
  { label: 'Property Type', fieldName: 'omniViewPropertyType', type: 'text' },
  { label: 'Property SubType', fieldName: 'subType', type: 'text' },
  { label: 'RSF', fieldName: 'squareFeet', type: 'number' },
  { label: 'Avg SF', fieldName: 'averageSizeSquareFeetPerUnit', type: 'number', decimalFormat: '0' },
  { label: 'Avg Rent/Unit', fieldName: 'averageRentPerUnit', type: 'currency', decimalFormat: '0' },
  { label: 'Avg Rent/SF', fieldName: 'averageRentPerSquareFeet', type: 'currency', decimalFormat: '2' },
  { label: 'MR/Bed', fieldName: 'averageRentPerBed', type: 'currency' }, ///////   { key: 'averageRentPerBed', label: 'MR/Bed', type: 'currency', for: ['rent'] },
  // { label: 'ER/Bed', fieldName: 'effectiveRentPerBedBySource', type: 'currency'}, /////// if cons....
  { label: 'Notes', fieldName: 'sourceNote', type: 'text' },
  { label: 'Owner Account Name', fieldName: 'salesforceAccountName', type: 'text' },
  { label: 'Owner Contact Name', fieldName: 'salesforceContactName', type: 'text' },
  { label: 'Owner Contact Phone', fieldName: 'currentOwnerPhone', type: 'text' },
  { label: 'Owner Contact Email', fieldName: 'currentOwnerEmail', type: 'text' },
  { label: 'Account Relationship Manager', fieldName: 'accountRelationshipManager', type: 'text' },
  { label: 'MB Account Status', fieldName: 'mbAccountStatus', type: 'text' },
  { label: 'Ownership Status', fieldName: 'ownershipStatus', type: 'text' },
]

export const ProspectingColumns = [
  { label: 'Property Name', fieldName: 'propertyName', type: 'text' },
  { label: 'Property Address', fieldName: 'addressLine1', type: 'text' },
  { label: 'City', fieldName: 'city', type: 'text' },
  { label: 'State', fieldName: 'state', type: 'text' },
  { label: 'Year Built', fieldName: 'yearBuilt', type: 'text' },
  { label: 'Year Renovated', fieldName: 'yearRenovated', type: 'text' },
  { label: 'Units', fieldName: 'propertyTotalUnits', type: 'number' },
  { label: 'Property Type', fieldName: 'omniViewPropertyType', type: 'text' },
  { label: 'Property SubType', fieldName: 'subType', type: 'text' },
  { label: 'RSF', fieldName: 'squareFeet', type: 'number' },
  { label: 'Metering', fieldName: 'metering', type: 'text' },
  { label: 'Sale Date', fieldName: 'saleDate', type: 'date' },
  { label: 'Sale Price', fieldName: 'salePrice', type: 'currency', decimalFormat: '0' },
  { label: 'Price per Unit', fieldName: 'transactionHistoryPricePerUnit', type: 'currency', decimalFormat: '0' },
  { label: 'Price per SF', fieldName: 'pricePerSf', type: 'currency', decimalFormat: '2' },
  { label: 'Cap Rate', fieldName: 'transactionHistoryCapRate', type: 'percent' },
  { label: 'GRM', fieldName: 'grossRentMultiplier', type: 'number', decimalFormat: '2' },
  { label: 'Terms', fieldName: 'termsOfSale', type: 'text' },
  { label: 'Owner Account Name', fieldName: 'salesforceAccountName', type: 'text' },
  { label: 'Owner Contact Name', fieldName: 'salesforceContactName', type: 'text' },
  { label: 'Owner Contact Phone', fieldName: 'currentOwnerPhone', type: 'text' },
  { label: 'Owner Contact Email', fieldName: 'currentOwnerEmail', type: 'text' },
  { label: 'Account Relationship Manager', fieldName: 'accountRelationshipManager', type: 'text' },
  { label: 'MB Account Status', fieldName: 'mbAccountStatus', type: 'text' },
  { label: 'Ownership Status', fieldName: 'ownershipStatus', type: 'text' },
]
